<template>
  <div
    ref="cont"
    class="progress-ring"
    :style="`--clr-stroke:${scoreClr};--clr-background:${scoreClr};--content-rotate:${
      maxCircle * -180 + startDeg
    }deg`"
  >
    <div class="progress-ring_content">
      <div class="progress-ring_back-ring" />
      <svg class="progress-ring_svg">
        <circle
          v-if="sizesSet"
          ref="circle"
          class="circle-front transition-always-on"
          :stroke-dasharray="circumference + ' ' + circumference"
          :style="`stroke-dashoffset: ${strokeDashoffset}`"
          :r="circleSize"
          :cx="circleSize"
          :cy="circleSize"
        />
      </svg>
    </div>
    <div
      v-if="hasNum"
      class="progress-ring_text"
    >
      <slot
        name="center"
        :num="progressNum"
      >
        <div class="progress-ring_num">{{ progressNum }}%</div>
      </slot>
    </div>
    <slot :num="progressNum"> </slot>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'ProgressRing',
  mixins: [format_mix],
  props: {
    // sizePx: { default: 100 },

    max: { default: 0.5 },
    maxCircle: { default: 1 },
    startDeg: { default: 180 },
    hasNum: { type: Boolean, default: true },
    changeColorIntervalMs: { default: 0 },
    getClr: {
      default: () => num =>
        num < 0.33 ? 'var(--clr-error)' : num < 0.66 ? 'var(--clr-yellow)' : 'var(--clr-primary)',
    },
  },
  emits: ['beforeDestroy', 'update:index'],
  data() {
    return {
      sizePx: 0,
      clrIndex: 0,
      progressNum: 0,

      sizesSet: false,
      circleSize: 0,
      circumference: 0,
      strokeDashoffset: 0,

      interval: -1,
      intervalSizeCheck: -1,
    }
  },
  mounted() {
    this.handleMounted(true)
  },
  beforeUnmount() {
    clearInterval(this.interval)
    clearInterval(this.intervalSizeCheck)
    this.$emit('beforeDestroy')
  },
  methods: {
    handleMounted(setSizeCheck) {
      // setTimeout(() => {
      nextTick(() => {
        this.progressNum = this.numFixed(this.max * 100)
        if (this.$refs.cont) {
          this.sizePx = this.$refs.cont.getBoundingClientRect().width
        }
        // this.sizePx = this.$refs.cont.clientWidth
        this.circleSize = this.sizePx * 0.5
        this.circumference = this.circleSize * 2 * Math.PI
        this.strokeDashoffset = this.circumference
        this.sizesSet = true

        // requestAnimationFrame(this.initialize)
        setTimeout(() => this.initialize(), 1) // firefox suddenly need this here to work
        // this.initialize()
        if (setSizeCheck) {
          this.intervalSizeCheck = setInterval(() => {
            const sizePx = this.$refs.cont.getBoundingClientRect().width
            if (sizePx !== this.sizePx) {
              this.handleMounted()
            }
          }, 1000)
        }
      })
    },
    initialize() {
      this.strokeDashoffset = this.circumference - this.maxCircle * this.max * this.circumference
      if (this.changeColorIntervalMs) {
        this.clrIndex += 1
        // this.$emit('update:index', this.clrIndex)
        this.interval = setInterval(() => {
          this.clrIndex += 1
          // this.$emit('update:index', this.clrIndex)
        }, this.changeColorIntervalMs)
      }
    },
  },
  computed: {
    scoreClr() {
      if (this.changeColorIntervalMs) {
        return this.getClr(this.clrIndex)
      }
      return this.getClr(this.max)
    },
  },
  watch: {
    max() {
      this.handleMounted()
    },
  },
}
</script>
<style lang="scss">
.progress-ring_num {
  color: var(--clr-stroke);
  font-size: var(--text-size);
  line-height: 1.1;
  font-weight: 700;
}
</style>
<style lang="scss" scoped>
svg {
  display: block;
  background-clip: content-box, padding-box;
  overflow: visible;
  position: relative;
  z-index: 1;
}
.progress-ring {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  --size: 6.25em;
  height: var(--size);
  width: var(--size);

  // --stroke-width: 6px;
  --stroke-width: 0.5em;
  --clr-stroke: white;
  --clr-stroke-back: var(--clr-black-2);
  --clr-fill: var(--clr-black-1);
  --anim-duration: 0.42s;
  --content-rotate: 180deg;
  --clr-content-back: transparent;
  --clr-text-back: transparent;

  --text-size: 1.5em;

  // box-shadow: inset 0 0 50px var(--clr-stroke),
  //   inset 20px 0 80px var(--clr-stroke), inset -20px 0 80px var(--clr-stroke),
  //   inset 20px 0 300px var(--clr-stroke), inset -20px 0 300px var(--clr-stroke),
  //   0 0 50px var(--clr-stroke), -10px 0 80px var(--clr-stroke),
  //   10px 0 80px var(--clr-stroke);

  // box-shadow: 0 0 24px var(--clr-stroke), 0 0 12px var(--clr-stroke);

  border-radius: 50%;
  &_content {
    position: absolute;
    // width: 100%;
    // height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(var(--content-rotate));
    background: var(--clr-content-back);
  }
  &:not(.progress-ring_no-background) {
    .progress-ring_content {
      &:before,
      &:after {
        content: '';
        position: absolute;
        background: black;
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
      &:after {
        content: '';
        background: var(--clr-stroke);
        opacity: 0.15;
        transition: 0.2s;
      }
    }
  }
  &_back-ring {
    height: calc(var(--size) + var(--stroke-width));
    width: calc(var(--size) + var(--stroke-width));
    border-radius: 50%;
    border: solid var(--stroke-width) var(--clr-stroke-back);
    position: absolute;
    z-index: 1;
  }
  &_svg {
    transform: rotate(270deg);
    position: relative;
    height: var(--size);
    width: var(--size);
  }
  .circle-front {
    stroke-width: var(--stroke-width);
    stroke-linecap: round;
    stroke: var(--clr-stroke);
    fill: var(--clr-fill);
    fill: transparent;
    // --stroke-dashoffset: 0;
    // stroke-dashoffset: var(--stroke-dashoffset);
    transition: stroke-dashoffset var(--anim-duration) linear, stroke 0.44s;
  }
  &_text {
    position: absolute;
    z-index: 3;
    text-align: center;
    height: calc(100% - (var(--stroke-width) * 2));
    width: calc(100% - (var(--stroke-width) * 2));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--clr-text-back);
  }
}
</style>
